/***********
 General
 ***********/

const headerElement = document.querySelector('#header');
const miniSearchContent = document.querySelector('#miniSearchContentResults');

document.addEventListener('DOMContentLoaded', function () {
    // drop swiper
    new Swiper(headerElement.querySelector('.swiper'), {
        slidesPerView: 1,
        pagination: {
            el: headerElement.querySelector('.swiper-pagination'),
        },
        autoplay: {
            delay: 4000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: true
    })
    // drop mobile swiper
    new Swiper(document.querySelector('#slider .swiper'), {
        slidesPerView: 1,
        pagination: {
            el: document.querySelector('#slider .swiper-pagination'),
        },
        autoplay: {
            delay: 4000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: true
    })
})


/******************
 Search Bar
 ******************/

// open search element
headerElement.querySelector('#headerSearch').addEventListener('click', function () {
    headerElement.querySelector('#headerSearchDisplay').classList.add('active');
    // clear current search input and focus cursor
    headerElement.querySelector('.headerSearchInput').value = "";
    headerElement.querySelector('.headerSearchInput').focus();
    document.querySelector('#miniSearchContentResults').innerHTML = `
    <div id="miniSearchContentResultsEmpty">No Results...</div>
    `;
    document.querySelector('#miniSearchContentSuggestions').classList.add('active');
    miniSearchReading();
})

// exit button
headerElement.querySelector('#headerSearchDisplayFormExit').addEventListener('click', function (e) {
    e.preventDefault();
    this.closest('#headerSearchDisplay').classList.remove('active');
    miniSearchReading(true);
})
// exit with background
document.querySelector('#miniSearchBackdrop').addEventListener('click', function () {
    document.querySelector('#headerSearchDisplay').classList.remove('active');
    miniSearchReading(true);
})

// listener on the search input
function miniSearchReading(reset = false) {
    // remove listener when closing
    if (reset) {
        // headerElement.querySelector('.headerSearchInput').removeEventListener('input', miniSearchReveal);
        // if mini search is showing, hide
        document.querySelector('#miniSearch')?.classList.remove('active');
        document.querySelector('body').classList.remove('noScroll');
        return
    }

    // check if mini search is visible
    let miniSearchVisible = false;

    document.querySelector('#miniSearch').classList.add('active');
    document.querySelector('body').classList.add('noScroll');

    // gathering search params
    let searchParams = "";
    headerElement.querySelector('.headerSearchInput').addEventListener('input', miniSearchReveal);


    async function miniSearchReveal(e) {
        // open the mini search
        if (!miniSearchVisible) {
            // document.querySelector('#miniSearch').classList.add('active');
            miniSearchVisible = true;
        }

        // get parameters
        searchParams = e.target.value;
        // if blank, hide the miniSearch
        if (searchParams === "") {
            // document.querySelector('#miniSearch').classList.remove('active');
            miniSearchVisible = false;
            return;
        }
        // search on input
        await activeSearch();
    }

    // searching for params using button
    headerElement.querySelector('#headerSearchDisplayFormIcon').addEventListener('click', async function (e) {
        e.preventDefault();
        await activeSearch();
    })

    async function activeSearch() {
        try {

            // add redirect to actual search page
            document.querySelector('#miniSearchContentTopLink span').innerHTML = searchParams;
            document.querySelector('#miniSearchContentTopLink').addEventListener('click', () => {
                window.location.href = `/search?q=${searchParams}&type=product`;
            })

            const response = await fetch(`/search/suggest.json?q=${searchParams}&resources[type]=product&resources[limit]=5`);
            const data = await response.json();
            const resultsArray = data.resources.results.products;
            const searchHTMLElements = [];

            if (resultsArray.length > 0) {
                for (let result of resultsArray) {
                  const isB2B = result.tags && result.tags.includes('B2B ONLY');
                    searchHTMLElements.push(`
                <a class="miniSearchItem" href="${result.url}">
                    <img class="miniSearchItemImage" src="${result.image}" alt="product image" />
                    <div class="miniSearchItemText">
                        <h3 class="miniSearchItemTitle">${result.title}</h3>
                        ${!isB2B ? `<p class="miniSearchItemPrice">$${result.price}</p>` : ''}
                    </div>
                </a>
                        `)
                }

                // add all items to content
                miniSearchContent.innerHTML = searchHTMLElements.join('');
                // hide suggested products
                document.querySelector('#miniSearchContentSuggestions').classList.remove('active');

            }
        } catch (error) {
            console.error(error.message);
        }
    }


}

/**************
 Mobile Nav
 ***************/

// open nav
function openNav() {
    const headerBottom = document.querySelector('#header').getBoundingClientRect().bottom;
    document.querySelector('#sliderContent').style.height = `calc(100% - ${headerBottom}px)`
    document.querySelector("#slider").classList.add("active");
    document.querySelector("body").classList.add("noScroll");
    document.querySelector('#sliderExit').classList.add('active');
    document.querySelector('#headerMenu').classList.remove('active');
}

// close nav
function closeNav() {
    // for smooth transition, add animation
    document.querySelector("#slider").classList.add("deactivate");
    // remove classes once animation has safely run
    setTimeout(() => {
        document.querySelector("#slider").classList.remove("active");
        document.querySelector("#slider").classList.remove("deactivate");
    }, 500);
    document.querySelector("body").classList.remove("noScroll");
    document.querySelector('#sliderExit').classList.remove('active');
    document.querySelector('#headerMenu').classList.add('active');

    // reset slider menu if submenu is open
    if (document.querySelector('.sliderNavItem.active')) {
        document.querySelector('.sliderNavItem.active').classList.remove('active');
    }
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// open and close sub menu
document.querySelectorAll('.headerNavItem.dropMenu .headerNavItemTitle').forEach(el => {
    el.addEventListener('click', function () {
        el.classList.toggle('active');
    })
});